"use client";

import { useEffect } from "react";

export function ConversionBeacon() {
  useEffect(() => {
    if (typeof window === "undefined") return;
    try {
      const url = new URL(window.location.href);
      const origem = url.searchParams.get("origem") || "geral";
      const utmSource = url.searchParams.get("utm_source") || "";
      const utmCampaign = url.searchParams.get("utm_campaign") || "";
      const utmMedium = url.searchParams.get("utm_medium") || "";

      const w = window as any;
      w.dataLayer = w.dataLayer || [];
      w.dataLayer.push({
        event: "conversion_thank_you",
        event_category: "lead",
        event_label: origem,
        form_origin: origem,
        utm_source: utmSource,
        utm_campaign: utmCampaign,
        utm_medium: utmMedium,
        page_location: window.location.href,
      });

      // Meta / Facebook Pixel
      if (typeof w.fbq === "function") {
        w.fbq("track", "Lead", {
          content_name: origem,
          content_category: "formulario",
        });
      }

      // Google Analytics 4 & Google Ads
      if (typeof w.gtag === "function") {
        w.gtag("event", "generate_lead", {
          event_category: "form",
          event_label: origem,
          form_origin: origem,
          utm_source: utmSource,
          utm_campaign: utmCampaign,
        });

        // Evento de conversão padrão do Google Ads
        w.gtag("event", "conversion", {
          send_to: "AW-17131091805",
          event_label: origem,
        });
      }
    } catch {
      /* ignora falhas de tracking para não interromper a UX */
    }
  }, []);

  return null;
}
